export const PDC_UNIT_TYPES = {
    MONOBLOCK: { text: "Monobloc", value: 1 },
    SPLIT: { text: "Split", value: 2 },
	HYDROSPLIT: { text: "Hydrosplit", value: 3 },
};

export const PDC_MANUFACTURERS = {
    SISTEMA: { text: "Sistema", value: 1 },
    DOMUSA: { text: "Domusa", value: 2 },
    MITSUBISHI: { text: "Mitsubishi", value: 3 },
    ARISTON: { text: "Ariston", value: 4 },
	SOLAX: { text: "Solax", value: 5 },
};

/** Indoor temperatures for the power table (°C), ordered from -20 to 7 */
export const ARISTON_TEMPERATURES = [-20, -15, -10, -7, -3, 0, 2, 7];

/** Selectable delivery temperatures for Ariston (°C) */
export const ARISTON_DELIVERY_TEMPERATURES = [35, 45, 55, 60];

export const PDC_CURRENTS = {
    MONO: { text: "Monofazic", value: 1 },
    TRI: { text: "Trifazic", value: 2 },
};

export const PDC_INTERNAL_UNIT_TYPES = {
    HYDROBOX: 1,
    HYDROTANK: 2,
	CONTROLBOX: 3,
};

export const pdcUnits = [
	{
		product_code: "1001.08.57",
		name: 'Unitate exterioara "Eco Inverter" 4,0 kw (220V) 1x16A - nou',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 4,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1004.11.57", "1003.04.57"],
	},
	{
		product_code: "1001.09.57",
		name: 'Unitate exterioara "Eco Inverter" 6,0 kw (220V) 1x16A - nou',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 6,
		dynamic_pump_power: {
			"-15": 5.7,
			"-7": 6,
			2: 5,
			7: 6,
		},
		availableInternalUnits: ["1004.11.57", "1003.04.57"],
	},
	{
		product_code: "1001.10.57",
		name: 'Unitate exterioara "Eco Inverter" 7,5 kw (220V) 1x16A - nou',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 7.5,
		dynamic_pump_power: {
			"-15": 6,
			"-7": 6.8,
			2: 6.5,
			7: 7.5,
		},
		availableInternalUnits: ["1004.11.57", "1003.04.57"],
	},
	{
		product_code: "1002.07.57",
		name: 'Unitate exterioara "Zubadan" 8,0 kw (380V) 3x16A (R32 cu racire)',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-15": 8,
			"-7": 8,
			2: 8,
			7: 6,
		},
		availableInternalUnits: ["1004.12.57", "1003.05.57"],
	},
	{
		product_code: "1002.08.57",
		name: 'Unitate exterioara "Zubadan" 10,0 kw (380V) 3x16A (R32 cu racire)',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 10,
		dynamic_pump_power: {
			"-15": 10,
			"-7": 10,
			2: 10,
			7: 8,
		},
		availableInternalUnits: ["1004.12.57", "1003.05.57"],
	},
	{
		product_code: "1002.09.57",
		name: 'Unitate exterioara "Zubadan" 12,0 kw (380V) 3x16A (R32 cu racire)',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-15": 12,
			"-7": 12,
			2: 12,
			7: 10,
		},
		availableInternalUnits: ["1004.12.57", "1003.05.57"],
	},
	{
		product_code: "1002.10.57",
		name: 'Unitate exterioara "Zubadan" 14,0 kw (380V) 3x16A (R32 cu racire)',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 14,
		dynamic_pump_power: {
			"-15": 14,
			"-7": 14,
			2: 14,
			7: 12,
		},
		availableInternalUnits: ["1004.12.57", "1003.05.57"],
	},
	{
		product_code: "1002.06.57",
		name: 'Unitate exterioara "Zubadan" 23,0 kw (380V) 3x25A',
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.MITSUBISHI.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 23,
		dynamic_pump_power: {
			"-15": 22.9,
			"-7": 23,
			2: 23,
			7: 23,
		},
		availableInternalUnits: ["1003.03.57"],
	},
	// {
	//     product_code: "1010.09.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 4 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 4,
	//     dynamic_pump_power: {
	//         "-15": 3.95,
	//         "-7": 3.96,
	//         2: 4.37,
	//         7: 4.76,
	//     },
	// },
	// {
	//     product_code: "1010.11.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 6 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 6,
	//     dynamic_pump_power: {
	//         "-15": 5.85,
	//         "-7": 6,
	//         2: 5.92,
	//         7: 6.08,
	//     },
	// },
	// {
	//     product_code: "1010.13.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 8 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 8,
	//     dynamic_pump_power: {
	//         "-15": 6.48,
	//         "-7": 6.6,
	//         2: 6.61,
	//         7: 7.81,
	//     },
	// },
	// {
	//     product_code: "1010.15.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 10 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 10,
	//     dynamic_pump_power: {
	//         "-15": 8.25,
	//         "-7": 8.3,
	//         2: 9.5,
	//         7: 10.1,
	//     },
	// },
	// {
	//     product_code: "1010.17.94",
	//     name: 'Pompa de caldura "Sistema-Home DT" H/C 10 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     default_pump_power: 10,
	//     dynamic_pump_power: {
	//         "-15": 8.25,
	//         "-7": 8.3,
	//         2: 9.5,
	//         7: 10.1,
	//     },
	// },
	// {
	//     product_code: "1010.19.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 12 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 12,
	//     dynamic_pump_power: {
	//         "-15": 8.94,
	//         "-7": 8.9,
	//         2: 10.3,
	//         7: 11.8,
	//     },
	// },
	// {
	//     product_code: "1010.21.94",
	//     name: 'Pompa de caldura "Sistema-Home DT" H/C 12 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     default_pump_power: 12,
	//     dynamic_pump_power: {
	//         "-15": 8.94,
	//         "-7": 8.9,
	//         2: 10.3,
	//         7: 11.8,
	//     },
	// },
	// {
	//     product_code: "1010.23.94",
	//     name: 'Pompa de caldura "Sistema-Home D" H/C 14 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 14,
	//     dynamic_pump_power: {
	//         "-15": 10.8,
	//         "-7": 10.7,
	//         2: 13,
	//         7: 14.1,
	//     },
	// },
	// {
	//     product_code: "1010.25.94",
	//     name: 'Pompa de caldura "Sistema-Home DT" H/C 14 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     default_pump_power: 14,
	//     dynamic_pump_power: {
	//         "-15": 10.8,
	//         "-7": 10.7,
	//         2: 13,
	//         7: 14.1,
	//     },
	// },
	// {
	//     product_code: '1010.27.94',
	//     name: "Pompa de caldura \"Sistema-Home D\" H/C 16 Kw",
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     dynamic_pump_power: {
	//         "-15": 10.2,
	//         "-7": 12,
	//         "2": 14.1,
	//         "7": 16.3,
	//     },
	// },
	// {
	//     product_code: '1010.29.94',
	//     name: "Pompa de caldura \"Sistema-Home DT\" H/C 16 Kw",
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     dynamic_pump_power: {
	//         "-15": 10.2,
	//         "-7": 12,
	//         "2": 14.1,
	//         "7": 16.3,
	//     },
	// },
	// {
	//     product_code: "1010.31.94",
	//     name: 'Pompa de caldura "Sistema-Home DT" H/C 18 Kw',
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.SISTEMA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     default_pump_power: 18,
	//     dynamic_pump_power: {
	//         "-15": 11.8,
	//         "-7": 12.6,
	//         2: 15.1,
	//         7: 17.9,
	//     },
	// },
	// {
	//     product_code: "1010.01.85",
	//     name: "Pompa de caldura Aer-Apa 6,21 kW (220V)",
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.DOMUSA.value,
	//     current: PDC_CURRENTS.MONO.value,
	//     default_pump_power: 6.21,
	//     dynamic_pump_power: {
	//         "-15": 3.5,
	//     },
	// },
	// {
	//     product_code: "1010.06.85",
	//     name: "Pompa de caldura Aer-Apa 16,80 kW (380V)",
	//     type: PDC_UNIT_TYPES.MONOBLOCK.value,
	//     manufacturer: PDC_MANUFACTURERS.DOMUSA.value,
	//     current: PDC_CURRENTS.TRI.value,
	//     default_pump_power: 16.8,
	//     dynamic_pump_power: {
	//         "-15": 9,
	//     },
	// },
	{
		product_code: "1016.01.103",
		name: "Nimbus Pocket 50 M R32",
		type: PDC_UNIT_TYPES.MONOBLOCK.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 5,
		dynamic_pump_power: {
			"-10": 4.87,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 3.24,
				"-15": 4.35,
				"-10": 4.87,
				"-7": 5.2,
				"-3": 5.96,
				0: 6.44,
				2: 6.66,
				7: 7.57,
			},
			45: {
				"-20": 3.01,
				"-15": 4.05,
				"-10": 4.53,
				"-7": 4.94,
				"-3": 5.66,
				0: 6.12,
				2: 6.33,
				7: 7.19,
			},
			55: {
				"-15": 3.84,
				"-10": 4.3,
				"-7": 4.69,
				"-3": 5.38,
				0: 5.81,
				2: 6.01,
				7: 6.83,
			},
			60: {
				"-10": 4.09,
				"-7": 4.46,
				"-3": 5.11,
				0: 5.52,
				2: 5.71,
				7: 6.49,
			},
		},
	},
	{
		product_code: "1016.02.103",
		name: "Nimbus Pocket 80 M R32",
		type: PDC_UNIT_TYPES.MONOBLOCK.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-10": 6.94,
		},

		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 5.8,
				"-15": 6.94,
				"-10": 7.58,
				"-7": 8.45,
				"-3": 9.75,
				0: 10.58,
				2: 10.75,
				7: 11.74,
			},
			45: {
				"-20": 5.39,
				"-15": 6.45,
				"-10": 7.05,
				"-7": 8.03,
				"-3": 9.27,
				0: 10.07,
				2: 10.21,
				7: 11.15,
			},
			55: {
				"-15": 6.13,
				"-10": 6.7,
				"-7": 7.63,
				"-3": 8.8,
				0: 9.31,
				2: 9.85,
				7: 10.5,
			},
			60: {
				"-10": 6.23,
				"-7": 7.24,
				"-3": 8.36,
				0: 8.84,
				2: 9.16,
				7: 9.98,
			},
		},
	},
	{
		product_code: "1016.03.103",
		name: "Nimbus Pocket 80 M-T R32 (trifazic)",
		type: PDC_UNIT_TYPES.MONOBLOCK.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-10": 6.94,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 5.8,
				"-15": 6.94,
				"-10": 7.58,
				"-7": 8.45,
				"-3": 9.75,
				0: 10.58,
				2: 10.75,
				7: 11.74,
			},
			45: {
				"-20": 5.39,
				"-15": 6.45,
				"-10": 7.05,
				"-7": 8.03,
				"-3": 9.27,
				0: 10.07,
				2: 10.21,
				7: 11.15,
			},
			55: {
				"-15": 6.13,
				"-10": 6.7,
				"-7": 7.63,
				"-3": 8.8,
				0: 9.55,
				2: 9.85,
				7: 10.59,
			},
			60: {
				"-10": 6.23,
				"-7": 7.24,
				"-3": 8.36,
				0: 8.84,
				2: 9.16,
				7: 9.98,
			},
		},
	},
	{
		product_code: "1016.04.103",
		name: "Nimbus Pocket 120 M R32",
		type: PDC_UNIT_TYPES.MONOBLOCK.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	{
		product_code: "1016.05.103",
		name: "Nimbus Pocket 120 M-T R32 (trifazic)",
		type: PDC_UNIT_TYPES.MONOBLOCK.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	// {
	// 	product_code: "1016.06.103",
	// 	name: "Nimbus Pocket 150 M R32",
	// 	type: PDC_UNIT_TYPES.MONOBLOCK.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.MONO.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.76,
	// 			"-15": 9.68,
	// 			"-10": 11.95,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.56,
	// 			"-7": 11.82,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	// {
	// 	product_code: "1016.07.103",
	// 	name: "Nimbus Pocket 150 M-T R32 (trifazic)",
	// 	type: PDC_UNIT_TYPES.MONOBLOCK.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.TRI.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.30,
	// 			"-15": 9.17,
	// 			"-10": 11.32,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.05,
	// 			"-7": 11.2,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	{
		product_code: "1017.01.103",
		name: "Nimbus Compact 50 M R32",
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 5,
		dynamic_pump_power: {
			"-10": 4.87,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 3.24,
				"-15": 4.35,
				"-10": 4.87,
				"-7": 5.2,
				"-3": 5.96,
				0: 6.44,
				2: 6.66,
				7: 7.57,
			},
			45: {
				"-20": 3.01,
				"-15": 4.05,
				"-10": 4.53,
				"-7": 4.94,
				"-3": 5.66,
				0: 6.12,
				2: 6.33,
				7: 7.19,
			},
			55: {
				"-15": 3.84,
				"-10": 4.3,
				"-7": 4.69,
				"-3": 5.38,
				0: 5.81,
				2: 6.01,
				7: 6.83,
			},
			60: {
				"-10": 4.09,
				"-7": 4.46,
				"-3": 5.11,
				0: 5.52,
				2: 5.71,
				7: 6.49,
			},
		},
	},
	{
		product_code: "1017.02.103",
		name: "Nimbus Compact 80 M R32",
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-10": 6.94,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 5.8,
				"-15": 6.94,
				"-10": 7.58,
				"-7": 8.45,
				"-3": 9.75,
				0: 10.58,
				2: 10.75,
				7: 11.74,
			},
			45: {
				"-20": 5.39,
				"-15": 6.45,
				"-10": 7.05,
				"-7": 8.03,
				"-3": 9.27,
				0: 10.07,
				2: 10.21,
				7: 11.15,
			},
			55: {
				"-15": 6.13,
				"-10": 6.7,
				"-7": 7.63,
				"-3": 8.8,
				0: 9.31,
				2: 9.85,
				7: 10.5,
			},
			60: {
				"-10": 6.23,
				"-7": 7.24,
				"-3": 8.36,
				0: 8.84,
				2: 9.16,
				7: 9.98,
			},
		},
	},
	{
		product_code: "1017.03.103",
		name: "Nimbus Compact 80 M-T R32 (trifazic)",
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-10": 6.94,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 5.8,
				"-15": 6.94,
				"-10": 7.58,
				"-7": 8.45,
				"-3": 9.75,
				0: 10.58,
				2: 10.75,
				7: 11.74,
			},
			45: {
				"-20": 5.39,
				"-15": 6.45,
				"-10": 7.05,
				"-7": 8.03,
				"-3": 9.27,
				0: 10.07,
				2: 10.21,
				7: 11.15,
			},
			55: {
				"-15": 6.13,
				"-10": 6.7,
				"-7": 7.63,
				"-3": 8.8,
				0: 9.55,
				2: 9.85,
				7: 10.59,
			},
			60: {
				"-10": 6.23,
				"-7": 7.24,
				"-3": 8.36,
				0: 8.84,
				2: 9.16,
				7: 9.98,
			},
		},
	},
	{
		product_code: "1017.04.103",
		name: "Nimbus Compact 120 M R32",
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	{
		product_code: "1017.05.103",
		name: "Nimbus Compact 120 M-T R32 (trifazic)",
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	// {
	// 	product_code: "1017.06.103",
	// 	name: "Nimbus Compact 150 M R32",
	// 	type: PDC_UNIT_TYPES.HYDROSPLIT.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.MONO.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.76,
	// 			"-15": 9.68,
	// 			"-10": 11.95,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.56,
	// 			"-7": 11.82,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	// {
	// 	product_code: "1017.07.103",
	// 	name: "Nimbus Compact 150 M-T R32 (trifazic)",
	// 	type: PDC_UNIT_TYPES.HYDROSPLIT.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.TRI.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.30,
	// 			"-15": 9.17,
	// 			"-10": 11.32,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.05,
	// 			"-7": 11.2,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	{
		product_code: "1019.01.103",
		name: "Nimbus Compact 50 S R32",
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 5,
		dynamic_pump_power: {
			"-10": 4.87,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 3.24,
				"-15": 4.35,
				"-10": 4.87,
				"-7": 5.2,
				"-3": 5.96,
				0: 6.44,
				2: 6.66,
				7: 7.57,
			},
			45: {
				"-20": 3.01,
				"-15": 4.05,
				"-10": 4.53,
				"-7": 4.94,
				"-3": 5.66,
				0: 6.12,
				2: 6.33,
				7: 7.19,
			},
			55: {
				"-15": 3.84,
				"-10": 4.3,
				"-7": 4.69,
				"-3": 5.38,
				0: 5.81,
				2: 6.01,
				7: 6.83,
			},
			60: {
				"-10": 4.09,
				"-7": 4.46,
				"-3": 5.11,
				0: 5.52,
				2: 5.71,
				7: 6.49,
			},
		},
	},
	{
		product_code: "1019.02.103",
		name: "Nimbus Compact 80 S R32",
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-10": 6.94,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 5.8,
				"-15": 6.94,
				"-10": 7.58,
				"-7": 8.45,
				"-3": 9.75,
				0: 10.58,
				2: 10.75,
				7: 11.74,
			},
			45: {
				"-20": 5.39,
				"-15": 6.45,
				"-10": 7.05,
				"-7": 8.03,
				"-3": 9.27,
				0: 10.07,
				2: 10.21,
				7: 11.15,
			},
			55: {
				"-15": 6.13,
				"-10": 6.7,
				"-7": 7.63,
				"-3": 8.8,
				0: 9.31,
				2: 9.85,
				7: 10.5,
			},
			60: {
				"-10": 6.23,
				"-7": 7.24,
				"-3": 8.36,
				0: 8.84,
				2: 9.16,
				7: 9.98,
			},
		},
	},
	{
		product_code: "1019.04.103",
		name: "Nimbus Compact 120 S R32",
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	{
		product_code: "1019.05.103",
		name: "Nimbus Compact 120 S-T R32 (trifazic)",
		type: PDC_UNIT_TYPES.SPLIT.value,
		manufacturer: PDC_MANUFACTURERS.ARISTON.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-10": 8.14,
		},
		dynamic_pump_power_by_delivery_temp: {
			35: {
				"-20": 6.65,
				"-15": 8.14,
				"-10": 10.51,
				"-7": 11.47,
				"-3": 12.36,
				0: 12.96,
				2: 13.86,
				7: 14.37,
			},
			45: {
				"-20": 5.98,
				"-15": 7.32,
				"-10": 9.46,
				"-7": 10.9,
				"-3": 11.74,
				0: 12.31,
				2: 13.01,
				7: 13.65,
			},
			55: {
				"-15": 6.59,
				"-10": 8.8,
				"-7": 10.44,
				"-3": 11.15,
				0: 12.39,
				2: 12.7,
				7: 13.21,
			},
			60: {
				"-10": 7.92,
				"-7": 9.92,
				"-3": 10.6,
				0: 11.77,
				2: 12.06,
				7: 12.67,
			},
		},
	},
	// {
	// 	product_code: "1019.06.103",
	// 	name: "Nimbus Compact 150 S R32",
	// 	type: PDC_UNIT_TYPES.SPLIT.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.MONO.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.76,
	// 			"-15": 9.68,
	// 			"-10": 11.95,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.56,
	// 			"-7": 11.82,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	// {
	// 	product_code: "1019.07.103",
	// 	name: "Nimbus Compact 150 S-T R32 (trifazic)",
	// 	type: PDC_UNIT_TYPES.SPLIT.value,
	// 	manufacturer: PDC_MANUFACTURERS.ARISTON.value,
	// 	current: PDC_CURRENTS.TRI.value,
	// 	default_pump_power: 15,
	// 	dynamic_pump_power: {
	// 		"-10": 10.19,
	// 	},
	// 	dynamic_pump_power_by_delivery_temp: {
	// 		35: {
	// 			"-20": 9.22,
	// 			"-15": 10.19,
	// 			"-10": 12.58,
	// 			"-7": 13.79,
	// 			"-3": 15.2,
	// 			0: 16.1,
	// 			2: 17.2,
	// 			7: 17.65,
	// 		},
	// 		45: {
	// 			"-20": 8.30,
	// 			"-15": 9.17,
	// 			"-10": 11.32,
	// 			"-7": 13.1,
	// 			"-3": 14.44,
	// 			0: 15.3,
	// 			2: 15.99,
	// 			7: 16.77,
	// 		},
	// 		55: {
	// 			"-15": 8.71,
	// 			"-10": 11.11,
	// 			"-7": 12.44,
	// 			"-3": 13.72,
	// 			0: 14.53,
	// 			2: 15.52,
	// 			7: 15.98,
	// 		},
	// 		60: {
	// 			"-10": 9.05,
	// 			"-7": 11.2,
	// 			"-3": 13.03,
	// 			0: 13.8,
	// 			2: 14.75,
	// 			7: 15.13,
	// 		},
	// 	},
	// },
	{
		product_code: "1022.01.89",
		name: 'Unitate externa Solax 8kW (monofazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.12.89", "1022.13.89"],
	},
	{
		product_code: "1022.02.89",
		name: 'Unitate externa Solax 10kW (monofazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 10,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.12.89", "1022.13.89"],
	},
	{
		product_code: "1022.03.89",
		name: 'Unitate externa Solax 12kW (monofazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.12.89", "1022.13.89"],
	},
	{
		product_code: "1022.04.89",
		name: 'Unitate externa Solax 14kW (monofazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 14,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.12.89", "1022.13.89"],
	},
	{
		product_code: "1022.05.89",
		name: 'Unitate externa Solax 16kW (monofazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.MONO.value,
		default_pump_power: 16,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.12.89", "1022.13.89"],
	},
	{
		product_code: "1022.06.89",
		name: 'Unitate externa Solax 8kW (trifazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 8,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.14.89", "1022.15.89"],
	},
	{
		product_code: "1022.07.89",
		name: 'Unitate externa Solax 10kW (trifazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 10,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.14.89", "1022.15.89"],
	},
	{
		product_code: "1022.08.89",
		name: 'Unitate externa Solax 12kW (trifazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 12,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.14.89", "1022.15.89"],
	},
	{
		product_code: "1022.09.89",
		name: 'Unitate externa Solax 14kW (trifazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 14,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.14.89", "1022.15.89"],
	},
	{
		product_code: "1022.10.89",
		name: 'Unitate externa Solax 16kW (trifazica)',
		type: PDC_UNIT_TYPES.HYDROSPLIT.value,
		manufacturer: PDC_MANUFACTURERS.SOLAX.value,
		current: PDC_CURRENTS.TRI.value,
		default_pump_power: 16,
		dynamic_pump_power: {
			"-15": 4.3,
			"-7": 5,
			2: 4,
			7: 4,
		},
		availableInternalUnits: ["1022.11.89", "1022.14.89", "1022.15.89"],
	},
];

export const pdcInternalUnits = [
    {
        product_code: "1003.02.57",
        name: 'Unitate interioara "Hydrobox N14"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
    {
        product_code: "1003.03.57",
        name: 'Unitate interioara "Hydrobox N23"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
    {
        product_code: "1003.04.57",
        name: 'Unitate interioara "Hydrobox P7"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
    {
        product_code: "1003.05.57",
        name: 'Unitate interioara "Hydrobox P14" - model nou',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
    {
        product_code: "1004.03.57",
        name: 'Unitate interioara "Hydrotank N14 180"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
    {
        product_code: "1004.04.57",
        name: 'Unitate interioara "Hydrotank N14 230"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
    {
        product_code: "1004.11.57",
        name: 'Unitate interioara "Hydrotank R7 200"',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
    {
        product_code: "1004.12.57",
        name: 'Unitate interioara "Hydrotank R14 200" - model nou',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
	{
        product_code: "1022.11.89",
        name: 'Unitate interna Controlbox Solax (monofazic/trifazic)',
        type: PDC_INTERNAL_UNIT_TYPES.CONTROLBOX,
    },
	{
        product_code: "1022.12.89",
        name: 'Unitate interna Hydrobox Solax (monofazic)',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
	{
        product_code: "1022.13.89",
        name: 'Unitate interna Hydrotank Solax (monofazic)',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
	{
        product_code: "1022.14.89",
        name: 'Unitate interna Hydrobox Solax (trifazic)',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROBOX,
    },
	{
        product_code: "1022.15.89",
        name: 'Unitate interna Hydrotank Solax (trifazic)',
        type: PDC_INTERNAL_UNIT_TYPES.HYDROTANK,
    },
];
